import React from 'react';

import ProfileTopHeader from '@/pages/profile/components/ProfileTopHeader';
import ProfileForm from '@/pages/profile/components/ProfileForm';

const ProfilePage: React.FC = () => {
  return (
    <>
      <ProfileTopHeader />
      <ProfileForm />
    </>
  )
}

export default ProfilePage;